module.exports = __webpack_public_path__ + "static/media/repair-o.04c279eb.svg";